export default {
    name: 'Indonesia',
    dimensions: {width: 18, height: 20},
    content: `
    <g>
      <path d="M1 1.4624V9.4624H17V1.4624C17 1.4624 15.91 5.4624 9 5.4624C2.09 5.4624 1 1.4624 1 1.4624Z" fill="none" stroke="currentColor" stroke-width="1.9677" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M5 18.4624L2 9.4624" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13 18.4624L16 9.4624" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.04004 15.1224H13.25" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9 18.4624V9.63245" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
